var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinDriveSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-3319.021 -8.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-3",
    "data-name": "Icon",
    transform: "translate(2911.021 -8947.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17244",
    "data-name": "Rectangle 17244",
    width: 16,
    height: 16,
    transform: "translate(408 8956)",
    fill: "#212121",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36248",
    "data-name": "Group 36248",
    transform: "translate(-22.893 7847.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32714",
    "data-name": "Path 32714",
    d: "M15.468,4.128,15.445,4.1a1.521,1.521,0,0,0-.2-.287,1.18,1.18,0,0,0-.778-.461c-.1-.06-.2-.114-.317-.18a5.2,5.2,0,0,0-1.463-.541L12.2,2.5A.418.418,0,0,1,12,2.389,8.017,8.017,0,0,0,8.8.228a6.163,6.163,0,0,0-4.4.427A10.616,10.616,0,0,0,1.27,3.3,5.709,5.709,0,0,0,.091,4.864a1.834,1.834,0,0,0-.1.91A1.214,1.214,0,0,0,.641,6.839l.5.257-.06-.55a2.561,2.561,0,0,1-.018-.287,2.028,2.028,0,0,1,4.057,0,2.409,2.409,0,0,1-.03.365l-.06.353h5.326l-.06-.353a2.409,2.409,0,0,1-.03-.365,2.028,2.028,0,1,1,4.057,0,2.18,2.18,0,0,1-.03.347l-.06.419.419-.084a1.638,1.638,0,0,0,1.221-1.053,1.722,1.722,0,0,0,.1-.568,1.665,1.665,0,0,0-.5-1.191M6.107.91V3.43L2.774,3.416A4.642,4.642,0,0,1,6.107.912m.778,2.527V.781A3.351,3.351,0,0,1,7.347.737a4.916,4.916,0,0,1,4.425,2.722Z",
    transform: "translate(430.922 1112.738)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M1.517,3.047A1.524,1.524,0,1,1,3.047,1.524,1.544,1.544,0,0,1,1.517,3.047",
    transform: "translate(432.453 1117.759)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6-2",
    "data-name": "Fill 6",
    d: "M1.517,3.047A1.524,1.524,0,1,1,3.047,1.524,1.544,1.544,0,0,1,1.517,3.047",
    transform: "translate(441.667 1117.759)",
    fill: "#ffffff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDriveSelected);
export default __webpack_public_path__ + "static/media/Pin_drive_selected.2c967db2a42afe01979a7e609fe77217.svg";
export { ForwardRef as ReactComponent };